// Replace this with your actual API endpoint

 /* const apiUrl = "https://your-server.com/api/customer-data"; */

 const apiUrl = "https://mtest4.yourdevelopmentserver.net/listpetprofiles.php";

// Get the customer ID from Shopify Liquid variables
const shopifyCustomerId = "{{ customer.id }}"; // This will be rendered by Shopify Liquid

fetch(`${apiUrl}?customer_id=${shopifyCustomerId}`)
  .then((response) => response.json())
  .then((data) => {
    console.log("API Response:", data);

    if (Array.isArray(data)) {
      const detailsContainer = document.getElementById("custom-details");
      if (detailsContainer) {
        detailsContainer.innerHTML = ""; // Clear existing content

        // Loop through the array and display each record
        for (let i = 0; i < data.length; i++) {
          detailsContainer.innerHTML += `
         
            <div class="record">
              <h4>Record ${i + 1}:</h4>
              <p><strong>Pet Name:</strong> ${data[i].pet_name  || "N/A"}</p>
              <p><strong>Pet Age:</strong> ${data[i].pet_age || "N/A"}</p>
              <p><strong>Pet Breed:</strong> ${data[i].pet_breed || "N/A"}</p>
              <p><strong>Pet Color:</strong> ${data[i].pet_color  || "N/A"}</p>
              <p><strong>Pet Type:</strong> ${data[i].pettype  || "N/A"}</p>
              <p><strong>Pet Weight:</strong> ${data[i].weight || "N/A"}</p>
              <p><strong>Pet's More Details:</strong> ${data[i].moredetails || "N/A"}</p>
            </div>
          `;
        }
      }
    } else {
      console.warn("Expected an array but got:", data);
    }
  })
  .catch((error) => {
    console.error("Error fetching customer data:", error);
  });